import { motion } from 'framer-motion';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import AddIcon from '~/shared/assets/add.icon.svg';
import { routes } from '~/shared/config/routes';
import { cn } from '~/shared/lib/cn.ts';
import { LinkTypes } from '~/shared/model/link-types.ts';
import { BurgerIcon } from '~/shared/ui/burger-icon';
import { Button } from '~/shared/ui/button';
import { NavLinks } from '~/shared/ui/nav-links';

type SidebarMenuProperties = {
  linkType: LinkTypes;
};

export function SidebarMenu({ linkType }: SidebarMenuProperties) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="z-50 md:hidden">
      <div className="flex w-7 cursor-pointer flex-col gap-1.5 text-3xl text-primary">
        <button
          aria-label="Open menu"
          type="button"
          onClick={() => setIsOpen(true)}
          className="text-3xl"
        >
          <BurgerIcon aria-label="Open menu" isOpen={false} />
        </button>
      </div>

      <motion.div
        initial={{ x: '100%' }}
        animate={{ x: isOpen ? 0 : '100%' }}
        transition={{ duration: 0.3 }}
        className={cn(
          'fixed right-0 top-0 h-full w-64 bg-background p-6 shadow-lg',
          'flex flex-col gap-4',
        )}
      >
        <button
          aria-label="Close menu"
          type="button"
          onClick={() => setIsOpen(false)}
          className="self-end"
        >
          <BurgerIcon aria-label="Close menu" isOpen />
        </button>

        <Link
          to={routes.dashboard.courses.create.get()}
          onClick={() => setIsOpen(false)}
        >
          <Button width="full" justify="start">
            Create new course
            <AddIcon />
          </Button>
        </Link>
        <NavLinks onLinkClick={() => setIsOpen(false)} linkType={linkType} />
      </motion.div>
    </div>
  );
}
